import { twMerge } from '@polyai/ui/utils/twMerge';

interface LoadingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

export const LoadingButton = ({
  className,
  children,
  ...props
}: LoadingButtonProps) => (
  <button
    aria-busy="true"
    aria-disabled="true"
    className={twMerge(
      'flex gap-xs1 items-center justify-center',
      'w-full h-[40px] py-xs2 px-sm2',
      'text-body-regular font-semibold text-primary',
      'bg-background border border-solid border-border-subtle rounded-full',
      'cursor-default pointer-events-none',
      className,
    )}
    disabled
    {...props}
  >
    {children}
  </button>
);
